<div class="w-full h-full overflow-auto hide-scroll flex content-start flex-wrap" infiniteScroll
  [infiniteScrollDistance]="2" [scrollWindow]="false" [infiniteScrollThrottle]="50" (scrolled)="loadMore()">
  <!-- ? Header -->
  <app-header class="sticky top-0   z-30 bg-white dark:bg-gray-900 shadow-sm" [_Config]="headerConfig"
    (filterReviews)="changeFilter(rateOrReviewTemplate.review)" (filterRates)="changeFilter(rateOrReviewTemplate.rate)">
  </app-header>

  <ng-container *ngIf="!loading; else skeletonTemplate">
    <div class="w-full mt-4 flex flex-wrap">
      <ng-container *ngIf="rateOrReview === rateOrReviewTemplate.review">
        <ng-container *ngFor="let review of reviews">
          <div class="w-full px-3 pb-3 mb-3 border-b border-gray-100 dark:border-gray-600">
            <!-- ? Actor -->
            <app-user-activity-info class="flex w-full mb-3" [User]="review | getUserData" [inside]="false">
            </app-user-activity-info>

            <!-- ? Book -->
            <ng-container *ngIf="review?.object?.data?.book">
              <app-behkhaan-book-card [_book]="review.object.data.book" [_horizontal]="true"></app-behkhaan-book-card>
            </ng-container>

            <!-- ? Reivew -->
            <a class="w-full flex">
              <app-review-item class="mt-3 w-full" [review]="review?.review?.data"></app-review-item>
            </a>

            <!-- ? Footer -->
            <app-activity-footer-pluse class="mt-3" [Activity]="review | footerItem : false"
              (usersClicked)="openUsersDialog($event)" [activeCommentLink]="true"
              (bookmarkClicked)="bookmarkItem($event)" (likeClicked)="likeItem($event)"></app-activity-footer-pluse>
          </div>
        </ng-container>
      </ng-container>

      <ng-container *ngIf="rateOrReview === rateOrReviewTemplate.rate">
        <ng-container *ngFor="let review of rates">
          <div class="w-full px-3 pb-3 mb-3 border-b border-gray-100 dark:border-gray-600">
            <!-- ? Actor -->
            <app-user-activity-info class="flex w-full mb-3" [User]="review | getUserData" [inside]="false">
            </app-user-activity-info>

            <!-- ? Book -->
            <ng-container *ngIf="review?.object?.data?.book">
              <app-behkhaan-book-card [_book]="review.object.data.book" [_horizontal]="true"></app-behkhaan-book-card>
            </ng-container>

            <!-- ? Reivew -->
            <a class="w-full flex">
              <app-review-item class="mt-3 w-full" [review]="review?.review?.data"></app-review-item>
            </a>

            <!-- ? Footer -->
            <app-activity-footer-pluse class="mt-3" [Activity]="review | footerItem : false"
              (usersClicked)="openUsersDialog($event)" [activeCommentLink]="true"
              (bookmarkClicked)="bookmarkItem($event)" (likeClicked)="likeItem($event)"></app-activity-footer-pluse>
          </div>
        </ng-container>
      </ng-container>

      <ng-container *ngIf="loadingMore">
        <div class="w-full" [ngClass]="{ hidden: !loadingMore }">
          <div class="w-full my-3 flex justify-center items-center">
            <div class="rounded-full flex justify-center items-center">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </ng-container>
</div>

<!-- ? Skeleton -->
<ng-template #skeletonTemplate>
  <div class="w-full md:px-3 flex flex-wrap">
    <div *ngFor="let item of [1, 1, 1, 1]" class="w-full mt-3">
      <ngx-skeleton-loader class="w-full" [theme]="{ height: '250px', width: '100%' }">
      </ngx-skeleton-loader>
    </div>
  </div>
</ng-template>